import { useLanguageTool } from "../hooks/useLanguageTool"
import { CheckStatus } from "../hooks/CheckStatus"
import classNames from "classnames"
import { VariantSelector } from "./VariantSelector"

type VariantToolbarProps = {
    triggerSpellcheck: () => void
    triggerParaphrase: () => void
    mode: "SpellCheck" | "Paraphrase"
}

const VariantToolbar = (props: VariantToolbarProps) => {

    const { status } = useLanguageTool()

    const disabled = status == CheckStatus.Checking

    const btnClasses = classNames({
        'bt-basic': true,
        "bt-basic-vermell": !disabled,
        "bt-basic-gris": disabled,
        'submit': true
      });

    const spellCheckButton = (<div className="btn-right">
        <input disabled={disabled} type="submit" className={btnClasses} name="_action_checkText" value="Revisa" 
            onClick={props.triggerSpellcheck}
        />
    </div>)

    const paraphraseButton = (<div className="btn-right">
        <input disabled={disabled} type="submit" className={btnClasses} name="_action_checkText" value="Parafraseja" 
            onClick={props.triggerParaphrase}
        />
    </div>)

    return (<div className="btns-corrector row">
        <div className="col-xs-12">
            { props.mode === "SpellCheck" ? <VariantSelector /> : <></> }
            { props.mode === "SpellCheck" ? spellCheckButton : paraphraseButton }
        </div>
    </div>)
}


export default VariantToolbar
